export const FUNCTION_TYPE = {
    CODE: "code",
    EXECUTOR: "executor",
};
export const OPERATION_TYPE = {
    READ: "read",
    WRITE: "write",
};
export const PARAMETER_TYPE = {
    STRING: "string",
    NUMBER: "number",
    BOOLEAN: "boolean",
    OBJECT: "object",
    /**
     * @deprecated Use `STRING_ARRAY`, `NUMBER_ARRAY`, or `OBJECT_ARRAY` instead.
     * Kept for backward compatibility — treated as `STRING_ARRAY` at runtime.
     */
    ARRAY: "array",
    /** Array of strings (`{ type: "array", items: { type: "string" } }`) */
    STRING_ARRAY: "string_array",
    /** Array of numbers (`{ type: "array", items: { type: "number" } }`) */
    NUMBER_ARRAY: "number_array",
    /** Array of objects (`{ type: "array", items: { type: "object" } }`) */
    OBJECT_ARRAY: "object_array",
};
export const FLOW_STEP_STATUS = {
    PENDING: "pending",
    RUNNING: "running",
    SUCCESS: "success",
    FAILED: "failed",
};
export const MESSAGE_ROLE = {
    USER: "user",
    ASSISTANT: "assistant",
};
export const MESSAGE_PART_TYPE = {
    TEXT: "text",
    REASONING: "reasoning",
    STEP_START: "step-start",
    FILE_ATTACHMENT: "data-file-attachment",
};
export const MESSAGE_PART_STATE = {
    STREAMING: "streaming",
};
export const TOOL_PART_STATE = {
    INPUT_STREAMING: "input-streaming",
    INPUT_AVAILABLE: "input-available",
    APPROVAL_REQUESTED: "approval-requested",
    APPROVAL_RESPONDED: "approval-responded",
    OUTPUT_AVAILABLE: "output-available",
    OUTPUT_ERROR: "output-error",
    OUTPUT_DENIED: "output-denied",
    CALL: "call",
    RESULT: "result",
};
export const TOOL_PART_TYPE_PREFIX = "tool-";
/**
 * Safely extract a human-readable error message from any thrown value.
 *
 * Handles:
 * - `Error` instances → `.message`
 * - Strings → returned directly
 * - Objects with `.message` or `.error` string fields → that field
 * - Other objects → `JSON.stringify`
 * - Primitives → `String()`
 */
export function getErrorMessage(error) {
    if (error instanceof Error)
        return error.message;
    if (typeof error === "string")
        return error;
    if (error != null && typeof error === "object") {
        // Common patterns: { message: "..." } or { error: "..." }
        const obj = error;
        if (typeof obj.message === "string" && obj.message)
            return obj.message;
        if (typeof obj.error === "string" && obj.error)
            return obj.error;
        try {
            return JSON.stringify(error);
        }
        catch {
            return "[object Object]";
        }
    }
    return String(error);
}
//# sourceMappingURL=constants.js.map